import {useAppSelector} from "../../../store/hooks/useAppSelector";
import {
  Card,
  CardProps,
  MapOpsModeFilter,
  RefServiceModeSelect, RefServiceStatusFacetSelect, RefServiceStatusSelect,
  ServiceEventTypeSelect,
  ServiceTypeSelect, Switch
} from "@ots-frontend/ots-ui";
import {getMapOpsModeFilter} from "../../../store/map/selectors";
import {useDispatch} from "react-redux";
import {Divider, Flex, ScrollArea, Stack, Title} from "@mantine/core";
import {setMapOpsModeFilter} from "../../../store/map/actions";
import React, {ChangeEvent, useCallback} from "react";
import {firstOrUndefined, isStringUndefinedOrBlank, ServiceEventType, ServiceTypeEntity} from "@ots-frontend/ots-data";
import {first} from "lodash";

export type OpsModeFilterPanelProps = CardProps & {}

export const OpsModeFilterPanel = (props: OpsModeFilterPanelProps) => {
  const {
    mih = 300,
    w = 250,
    mah = "100%",
    shadow = "sm",
    padding = "lg",
    radius = "md",
    withBorder = true,
    ...rest
  } = props

  const dispatch = useDispatch()
  const filter = useAppSelector<MapOpsModeFilter>(getMapOpsModeFilter)

  const onServiceEventTypeChange = useCallback((types: ServiceEventType[]) => {
    dispatch(setMapOpsModeFilter({
      ...filter ?? {},
      serviceEventType: firstOrUndefined(types),
    }))
  }, [dispatch, filter])

  const onHeatmapChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    dispatch(setMapOpsModeFilter({
      ...filter ?? {},
      heatmap: e.currentTarget.checked,
    }))
  }, [dispatch, filter])

  const onServiceTypeChange = useCallback((entities: ServiceTypeEntity[]) => {
    dispatch(setMapOpsModeFilter({
      ...filter ?? {},
      serviceTypeId: first(entities)?.id
    }))
  }, [dispatch, filter])

  const onServiceStatusFacetChange = useCallback((value: string | null) => {
    dispatch(setMapOpsModeFilter({
      ...filter ?? {},
      statusFacet: isStringUndefinedOrBlank(value) ? undefined : value
    }))
  }, [dispatch, filter])

  const onServiceStatusChange = useCallback((value: string | null) => {
    dispatch(setMapOpsModeFilter({
      ...filter ?? {},
      status: isStringUndefinedOrBlank(value) ? undefined : value
    }))
  }, [dispatch, filter])

  const onServiceModeChange = useCallback((value: string | null) => {
    dispatch(setMapOpsModeFilter({
      ...filter ?? {},
      serviceMode: isStringUndefinedOrBlank(value) ? undefined : value
    }))
  }, [dispatch, filter])

  return (
    <ScrollArea h="100%" type="hover" scrollHideDelay={100}>
      <Card
        {...rest}
        mih={mih}
        w={w}
        mah={mah}
        shadow={shadow}
        padding={padding}
        radius={radius}
        withBorder={withBorder}>
        <Stack spacing="xs">

          <Flex>
            <Title order={5}>
              Ops Mode Filter
            </Title>
          </Flex>

          <Divider/>

          <ServiceEventTypeSelect
            label="Service Event Type"
            placeholder="Service Event Type"
            searchable
            clearable
            withinPortal={true}
            value={filter?.serviceEventType?.code}
            onDbCodeChange={onServiceEventTypeChange}/>

          {filter?.serviceEventType &&
            <Switch
              checked={filter?.heatmap}
              onChange={onHeatmapChange}
              color="service-work"
              size="xs"
              label="Heatmap"
            />
          }

          <ServiceTypeSelect
            label="Service Type"
            placeholder="Service Type"
            searchable
            clearable
            withinPortal={true}
            value={filter?.serviceTypeId}
            onEntityChange={onServiceTypeChange}/>

          <RefServiceStatusFacetSelect
            label="Service Status Facet"
            placeholder="Service Status Facet"
            searchable
            clearable
            withinPortal={true}
            value={filter?.statusFacet}
            onChange={onServiceStatusFacetChange}/>

          <RefServiceStatusSelect
            label="Service Status"
            placeholder="Service Status"
            searchable
            clearable
            withinPortal={true}
            value={filter?.status}
            onChange={onServiceStatusChange}/>

          <RefServiceModeSelect
            label="Service Mode"
            placeholder="Service Mode"
            searchable
            clearable
            withinPortal={true}
            value={filter?.serviceMode}
            onChange={onServiceModeChange}/>
        </Stack>
      </Card>
    </ScrollArea>
  )
}
